import { Card } from '@/components/ui/card';

export default function PrivacyPage() {
    return (
        <div className="py-10 sm:py-14" data-testid="privacy-page">
            <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
                <h1 className="font-[var(--font-display)] tracking-tight text-3xl font-bold text-[var(--brand-navy)] mb-6">Política de Privacidad</h1>
                <Card className="p-6 sm:p-8 rounded-xl space-y-5 text-sm text-[hsl(var(--muted-foreground))] leading-relaxed">
                    <section>
                        <h2 className="font-[var(--font-display)] font-semibold text-base text-[hsl(var(--foreground))] mb-2">1. Responsable del tratamiento</h2>
                        <ul className="list-disc pl-5 space-y-1">
                            <li><strong>Responsable:</strong> Auto Sport Gómez S.L.U. (nombre comercial: ASG Motor)</li>
                            <li><strong>NIF:</strong> B06741409</li>
                            <li><strong>Dirección:</strong> Avda. de Córdoba 15, 06400 Don Benito, Badajoz</li>
                            <li><strong>Email:</strong> info@asgmotor.com</li>
                            <li><strong>Teléfono:</strong> +34 627 94 76 22</li>
                        </ul>
                    </section>
                    <section>
                        <h2 className="font-[var(--font-display)] font-semibold text-base text-[hsl(var(--foreground))] mb-2">2. Datos que recopilamos</h2>
                        <p>Recopilamos los datos que nos proporcionas voluntariamente a través de:</p>
                        <ul className="list-disc pl-5 mt-2 space-y-1">
                            <li><strong>Formulario de contacto:</strong> nombre, teléfono, email y mensaje.</li>
                            <li><strong>WhatsApp/llamadas:</strong> registramos el evento de clic (sin datos personales).</li>
                        </ul>
                    </section>
                    <section>
                        <h2 className="font-[var(--font-display)] font-semibold text-base text-[hsl(var(--foreground))] mb-2">3. Finalidad del tratamiento</h2>
                        <ul className="list-disc pl-5 space-y-1">
                            <li>Atender tus consultas y solicitudes de información sobre vehículos.</li>
                            <li>Gestionar presupuestos y citas.</li>
                            <li>Mejorar nuestros servicios mediante estadísticas anónimas de uso.</li>
                        </ul>
                    </section>
                    <section>
                        <h2 className="font-[var(--font-display)] font-semibold text-base text-[hsl(var(--foreground))] mb-2">4. Base legal</h2>
                        <p>El tratamiento se basa en tu <strong>consentimiento</strong> (art. 6.1.a RGPD) al enviar el formulario y en el <strong>interés legítimo</strong> (art. 6.1.f RGPD) para estadísticas de uso.</p>
                    </section>
                    <section>
                        <h2 className="font-[var(--font-display)] font-semibold text-base text-[hsl(var(--foreground))] mb-2">5. Conservación de datos</h2>
                        <p>Tus datos se conservarán mientras sean necesarios para la finalidad indicada y, en todo caso, durante los plazos legales exigidos.</p>
                    </section>
                    <section>
                        <h2 className="font-[var(--font-display)] font-semibold text-base text-[hsl(var(--foreground))] mb-2">6. Tus derechos</h2>
                        <p>Puedes ejercer tus derechos de acceso, rectificación, supresión, limitación, portabilidad y oposición enviando un email a <strong>info@asgmotor.com</strong> indicando tu nombre y el derecho que deseas ejercer.</p>
                        <p className="mt-2">También tienes derecho a presentar una reclamación ante la <strong>Agencia Espa\u00f1ola de Protección de Datos</strong> (www.aepd.es).</p>
                    </section>
                    <section>
                        <h2 className="font-[var(--font-display)] font-semibold text-base text-[hsl(var(--foreground))] mb-2">7. Cesiones de datos</h2>
                        <p>No cedemos tus datos a terceros salvo obligación legal.</p>
                    </section>
                </Card>
            </div>
        </div>
    );
}
